module.exports = __webpack_public_path__ + "media/images/forward_enabled-6eba0eacd722b9cceed3b2ecf8aef145.png";